import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/notifications/edit/:id',
	title:       'menu.notification-edit',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/notifications/edit/:id';
	},
});
